<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="reportId"
            search-url="/acceptanceReport/search?sortField=status,reportId&"
            create-url="/acceptanceReport/save"
            form-type="intable"
            @createNew="openCreateDialog"
            ref="tableData"
            :deleteMulti="false"
            :acceptView="true"
            :acceptEdit="false"
            :acceptDelete="false"
            :acceptCreate="roleGroup == 1"
            :customCreateNew="true"
            @viewItem="viewItem"
            @setLastSearchValues="setLastSearchValues"
            :lastSearchValues="lastSearchValues"
            orderBy="asc,desc"
        />
        
        <modal-order-request
            :areas="areas"
            :dialog="dialog"
            @close="close"
            @selectRequest="selectRequest"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import moment from "moment";
import { requestConstants, roleConstants } from "@/constants";
import ModalOrderRequest from "./component/ModalOrderRequest.vue";

export default {
    name: "acceptanceReportList",
    components: { CSearchForm, ModalOrderRequest },
    data: () => {
        return {
            formName: "Danh sách biên bản nghiệm thu",
            roleGroup: 0,
            dialog: false,
            areas: [],
            lastSearchValues: {},
            itemCreate: {
                reqOrdId: '',
                requestOrderNumber: '',
            },
            active_tab: 0,
            tabs: [
                {id: 1, name: 'Thông báo giao hàng'},
                {id: 2, name: 'Phiếu nhập kho'},
            ],
            searchUrl: "",
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "reportNumber",
                    text: "Số biên bản",
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "requestOrderNumber",
                    text: "Số đề nghị",
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "reportDate",
                    text: "Ngày tạo biên bản",
                    headerStyle: "text-align:center",
                    dateFormat: "dd/MM/yyyy",
                    search: true,
                    type: "datepicker"
                },
                {
                    value: "areaId",
                    text: "Khu nuôi",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "areaId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: [],
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    width: "5%",
                    text: "lang.common.actions",
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        let queryParam = this.$route.query;

        // 2: thủ kho;  26: mua hàng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role == 26 || role == 3) {
            this.roleGroup = 1;
        }

        let searchImportRequest = queryParam.searchImportRequest;
        if(searchImportRequest !=undefined){
            try{
                this.lastSearchValues = JSON.parse(searchImportRequest);
            } catch (e){

            }
        }

        this.getPondArea();
        this.setStatus();
    },

    methods: {
        setLastSearchValues: function (values) {
            this.lastSearchValues = Object.assign(this.lastSearchValues, values);
        },
        createParamLastSearch: function (values) {
            const obj1 = {
                searchImportRequest: JSON.stringify(values),
            };
            const obj2 = this.$route.query;
            return {...obj1, ...obj2};
        },
        openCreateDialog: function () {
            this.dialog = true;
        },
        viewItem: function (item) {
            this.$router.push({ path: '/acceptanceReport/view/' + item.reportId, query: this.createParamLastSearch(this.lastSearchValues)  });
        },
        close() {
            this.dialog = false;
        },
        selectRequest(reqOrdId) {
            this.dialog = false;
            this.$router.push({ path: '/acceptanceReport/create/' + reqOrdId });
        },
        getPondArea() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/myArea"
            )
            .then((data) => {
                if (data.length > 0) {
                    this.areas = data;
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "areaId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data;
                    }
                }
            });
        },
        dateFormat(date) {
            return moment(String(date)).format('DD-MM-YYYY');
        },
        setStatus() {
            let status = requestConstants.acceptanceReportStatus;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
                status = status.filter(function (e) {
                    return e.value >= 2;
                });
            }

            // this.requestStatus = status;
            let itemFields = this.fields.filter(function (e) {
                return e.name == "status";
            });
            if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = status;
            }
        },
    },
    destroyed() {},
};
</script>
